export default __webpack_public_path__ + "media/images/about-hero-f8cf109f8ad6603d06fb4071fd33ad90.jpg";